module.exports = __webpack_public_path__ + "static/lil-brownie-house-logo-909de47de9361414eaecc2e9f27ef56b.png";